import { httpPost } from './utils';

const api = {
  fetchList: (url, body) => httpPost(url, body),
};

export default api;
